import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { delay, first, of } from 'rxjs';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html'
})
export class DialogComponent implements OnInit {
  textAreaNgModel = '' as string;
  maxLength: number = 100;
  currentUrl: string;
  isDialogOpen = false as boolean;
  dialogType = 'default' as string;
  closequeryparam: any = { openDialog: false };

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.currentUrl = this.router.url.split('?')[0];
  }

  ngOnInit(): void {
    this.getOpenDialogParam();
  }

  private getOpenDialogParam(): void {
    this.activatedRoute.queryParams.subscribe(res => {
      if (res.dialogType) {
        this.dialogType = res.dialogType;   
      }
      if (res.openDialog && res.openDialog === 'true') {
        this.isDialogOpen = true;
      } else {
        this.isDialogOpen = false;
        
        let closeId = document.getElementById(this.dialogType+'Id');
        closeId?.focus();      
      
      }
    });
  }
}